import { useState, useEffect, useCallback } from 'react';
import LoginStore from '../stores/LoginStore';
import Constants from '../constants/Constants';

/**
 * useAuth - 로그인 상태를 자동으로 감지하는 커스텀 훅
 *
 * LoginStore를 구독하여 인증 상태 변경 시 자동으로 업데이트됩니다.
 *
 * @returns {{
 *   isLoggedIn: boolean,
 *   isAdmin: boolean,
 *   authInfo: object,
 *   fullName: string,
 *   userId: number|null
 * }}
 */
function useAuth() {
  const [authInfo, setAuthInfo] = useState(LoginStore.authInfo);

  const handleStoreChange = useCallback(() => {
    setAuthInfo(LoginStore.authInfo);
  }, []);

  useEffect(() => {
    // LoginStore 변경 구독
    LoginStore.addChangeListener(handleStoreChange);

    // 초기 상태 동기화
    setAuthInfo(LoginStore.authInfo);

    // 클린업: 구독 해제
    return () => {
      LoginStore.removeChangeListener(handleStoreChange);
    };
  }, [handleStoreChange]);

  // 로그인 여부 계산
  const isLoggedIn = authInfo?.status === Constants.AUTHED;

  // 관리자 여부 계산
  const isAdmin = isLoggedIn && authInfo?.data?.admin === true;

  // 사용자 이름
  const fullName = isLoggedIn
    ? `${authInfo?.data?.lastName || ''} ${authInfo?.data?.firstName || ''}`.trim()
    : '';

  // 사용자 ID
  const userId = isLoggedIn ? authInfo?.data?.id || null : null;

  return {
    isLoggedIn,
    isAdmin,
    authInfo,
    fullName,
    userId,
  };
}

export default useAuth;
